// extracted by mini-css-extract-plugin
export default {"wrapper":"P1-z","play":"Q1-z"};